import { PRIMARY_OUTLET, Router, UrlTree } from '@angular/router';

function getNavigationUrl(router: Router): UrlTree {
  const navigation = router.getCurrentNavigation();
  return navigation?.finalUrl ?? navigation?.extractedUrl ?? router.parseUrl(router.url);
}

export function getSsoLoginOverride(router: Router): boolean | null {
  const value = getNavigationUrl(router).queryParamMap.get('sso');
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return null;
}

function isLoginUrl(url: UrlTree): boolean {
  const segments = url.root.children[PRIMARY_OUTLET]?.segments;
  return segments?.length === 1 && segments[0].path === 'login';
}

export function redirectToLogin(router: Router): void {
  if (isLoginUrl(getNavigationUrl(router))) {
    return;
  }

  const sso = getSsoLoginOverride(router);
  void router.navigate(['/login'], {
    queryParams: sso === null ? {} : { sso },
  });
}
